const resources = {
  zh: {
    translation: {
      "Please select": "請選擇",
      "Fill in the information": "填寫資料",
      Prefix: "* 稱謂",
      Mr: "Mr 先生",
      Mrs: "Mrs 太太",
      Ms: "Ms 女士",
      Miss: "Miss小姐 ",
      Dr: "Dr 博士",
      Professor: "Professor 教授",
      Others: "Others 其他",
      "Chinese lastname": "中文姓氏",
      "Chinese firstname": "中文名字",
      "English lastname": "* 英文姓氏",
      "English firstname": "* 英文名字",
      Gender: "性別",
      Male: "男",
      Female: "女",
      Other: "其他",
      Email: "* 電郵",
      "Confirm email": "* 確認電郵",
      "Phone type": "* 聯絡電話類型",
      Local: "本地",
      International: "海外",
      "Phone No.": "* 電話號碼",
      "Select payment method": "選擇付款方法",
      Required: "必需填寫",
      "Invalid email": "請輸入正確的電郵地址",
      "Email Confrimation does not match email": "確認電郵與電郵不相符",
      "Invalid Phone no.": "請輸入正確的手提電話號碼",
      "Year of Birth": "出生年份",
      "Invalid Year of Birth": "請輸入正確的出生年份",
      "Month of Birth": "出生月份",
      "Receipt Name": "免稅收據抬頭名稱",
      "Receipt Address": "收據郵寄地址",
      "Receipt HelperText": "收據會發送到您的電子郵箱， 如需紙本收據，請填寫地址。",
      Job: "職業",
      LivingArea: "居住地區",
      Attachment: "補充資料",
      Browse: "瀏覽",
      "Upload a file": "上傳檔案",
      "Personal Information Collection Statement": "《收集個人資料聲明》",
      Clear: "重新輸入",
      Submit: "提交",
      Donation: "善心捐款",
      "Event Enrollment": "活動報名",
      "Transaction Result": "交易結果",
      "Transaction Failed": "交易過時",
      Back: "返回",
      "Donation Amount": "單次捐款金額",
      "Other Amount": "其他金額",
      "Custom Amount": "自訂金額",
      "Not less than 50": "網上捐款最低限額為港幣50元",
      "Need receipt": "是否需要捐款收據（捐款港幣$100以上才予收據）",
      Yes: "是",
      No: "否",
      "Please scan": "請掃瞄 QR Code 進行付款",
      Confirmation: "確認資料",
      "FPS Payment": "FPS 付款",
      "Card Payment": "信用卡支付",
      "Event Page diabled": "有關心呼吸的資訊，請前往網頁：",
      "Event Page diabled Email": "如有任何查詢，歡迎電郵至",
      // "Event Page diabled": "此活動已取消。相關資訊請留意本機構的網站或電郵至",
      disabled_full: "此活動已額滿，謝謝支持！相關資訊請留意本機構的網站或電郵至",
      disabled_expired: "此活動已截止報名，謝謝支持！相關資訊請留意本機構的網站或電郵至",
      disabled_stop: "此活動已截止報名，謝謝支持！相關資訊請留意本機構的網站或電郵至",
      disabled_cancel: "此活動已取消。相關資訊請留意本機構的網站或電郵至",
      disabled_pause: "此活動已暫停報名。相關資訊請留意本機構的網站或電郵至",
      "learn more": "了解更多。",
      "Please wait FPS": "請稍後片刻，系統將跳轉到FPS付款頁面",
      "Please wait PayMe": "請稍後片刻，系統將跳轉到PayMe付款頁面",
      "Please scan - Event": "*請在10分鐘內完成交易，否則系統將不會保留該名額，用戶需要重新進行登記。",
      "Please scan - Donation": "*請在10分鐘內完成交易。",
      "QR code title": "請使用銀行手機應用程式掃瞄以下二維碼",
      "PayCode title": "請用 PayMe 掃描此 PayCode",
      "Card title": "請填寫您的信用卡信息",
      "Donation Success Result": "交易結果",
      "Donation Fail Result": "操作過時",
      "Donation Transaction Fail Result": "付款失敗",
      "Event Success Result": "報名結果",
      "Event Fail Result": "操作過時",
      "Event Transaction Fail Result": "付款失敗",
      "Don't close": "交易完成前請不要關閉此頁面",
      "QR payment 1": "打開支援「轉數快」的銀行手機應用程式或支付應用程式。",
      "QR payment 2": "掃描二維碼，查閱交易詳情並確認付款指引。",
      "QR payment 2 info": "如你是使用流動裝置，你只需要將此頁的二維碼截圖並上載至應用程式以完成結帳。",
      "QR payment 3": "在應用程式完成付款後，請留在此頁面等待確認。",
      "QR payment 3 info": "有關應用程式的詳細資訊，請與該支付服務供應商聯繫。",
      "QR payment 0 PayMe": "如何用 PayMe 付款？",
      "QR payment 1 PayMe": "打開 PayMe 應用程式",
      "QR payment 2 PayMe": "掃描 PayCode 以授權付款",
      "QR payment 3 PayMe": "在 PayMe 完成交易後，請留在此頁面等待確認",
    },
  },
  en: {
    translation: {
      "Please select": "Please select",
      "Fill in the information": "Please Fill in the information",
    },
  },
};

export default resources;
